import type { Event } from '../types/calendar';

// Format date for Google Calendar URL
const formatDate = (date: Date | string) => {
  const d = new Date(date);
  return d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
};

// Get recurrence rule for Google Calendar
const getRecurrenceRule = (event: Event) => {
  if (!event.recurrence) return '';

  const freq = event.recurrence.frequency.toUpperCase();
  const interval = event.recurrence.interval;
  
  return `&recur=RRULE:FREQ=${freq};INTERVAL=${interval}`;
};

// Get event color for Google Calendar
const getEventColor = (event: Event) => {
  const hex = event.color?.replace('#', '') || '4F46E5';
  return `&color=%23${hex}`;
};

// Generate Google Calendar event URL
export const generateGoogleCalendarUrl = (event: Event) => {
  const details = [
    'Evento criado via Kontty',
    '',
    `Plataforma: ${event.platform}`,
    `Prioridade: ${event.priority}`,
    `Status: ${event.status}`
  ];

  // Add content plan or idea details if available
  if (event.contentPlanId) {
    details.push('', `Plano vinculado: ${event.title}`);
  }
  if (event.contentIdeaId) {
    details.push('', `Ideia vinculada: ${event.title}`);
  }

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.title,
    dates: `${formatDate(event.start)}/${formatDate(event.end)}`,
    details: details.join('\n'),
  });

  let url = `https://calendar.google.com/calendar/render?${params.toString()}`;
  
  // Add recurrence if set
  if (event.recurrence) {
    url += getRecurrenceRule(event);
  }

  // Add event color
  url += getEventColor(event);

  return url;
};